import { useIntl } from 'react-intl';

import type { SgNumberInputProps } from '@/components/sg-design-system/components/input/SgNumberInput/types.ts';

import { SgNumberInput } from '../SgNumberInput';

export const SgAmountInput = (props: SgNumberInputProps) => {
  const { locale } = useIntl();

  return (
    <SgNumberInput
      size="sm"
      {...props}
      valuePosition="start"
      unitPosition="end"
      locale={locale}
      selectAllOnFocus
      acceleratorsEnabled
    />
  );
};
